// Общие хелперы форматирования для страниц статистики.

export const formatMoney = (value: number | null | undefined): string => {
    const num = Number(value ?? 0);
    return `${num.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
};

export const formatDate = (value?: string | null): string => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString("ru-RU");
};

// Склонение слова "способ" для сводки в раскрывающейся подсказке (1 способ, 2 способа, 5 способов).
export const pluralizePaymentTypes = (count: number): string => {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod10 === 1 && mod100 !== 11) return `${count} способ`;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${count} способа`;
    return `${count} способов`;
};
